import React, { useEffect, useState } from 'react'
import { useLocation, useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { RingCentralClient } from '../../../lib/ringcentral/ringCentral'
import { Button } from 'reactstrap'
import { updateAuthData } from '../redux/userActions'

const LoginToRCRoute = (props) => {
  const [message, setMessage] = useState('Please wait for system to login!')
  const { search } = useLocation()
  const history = useHistory()
  const dispatch = useDispatch()

  const searchParams = new URLSearchParams(search)
  const code = searchParams.get('code')
  const state = searchParams.get('state')

  useEffect(() => {
    const getAuthData = async (code, userId) => {
      const instance = new RingCentralClient(userId)
      const authData = await instance.getToken(code)

      return authData
    }

    const loadData = async () => {
      if (code && state) {
        try {
          const { userId } = JSON.parse(state)

          const authData = await getAuthData(code, userId)

          if (!Object.keys(authData).length) {
            throw new Error('Authorization code expired')
          }
          await dispatch(updateAuthData(authData, userId))

          setMessage('Successfully logged in!')
        } catch (e) {
          setMessage(`Error: ${e.message}. Please contact dev support with the message screenshot, or try login again!`)
        }
      }
    }

    loadData()
  }, [])

  const onGoBackClick = () => {
    history.push('/')
  }

  return (
    <div
      style={{
        display: 'grid',
        placeItems: 'center',
        width: '100vw',
        height: '100vh',
      }}
    >
      <div className='d-flex flex-column align-items-center justify-content-center'>
        <p>{message}</p>
        <Button className='btn btn-sm gold-color-button mt-2 ml-2' onClick={onGoBackClick}>
          <i class='fas fa-arrow-left mr-2'></i> Go back to dashboard
        </Button>
      </div>
    </div>
  )
}

export { LoginToRCRoute }
